import axios from 'axios';

export const ProjectDetails = {
  async fetchprojectDetails(projectId) {
    try {
      const response = await axios.post('/show_project', {project_id: projectId});
      return response.data; // Return the entire response object
    } catch (error) {
      console.error('Error fetching images:', error);
      return null; // Return null in case of an error
    }
  }
};
